const convertByteToImageURL = (bufferData: any) => {
    const buffer = new Uint8Array(bufferData);
    const blob = new Blob([buffer], { type: 'image/png'});
    const url = URL.createObjectURL(blob);
    return url;
}
export default convertByteToImageURL;